import { render, staticRenderFns } from "./graph_methanogenic_potential_per_interface.vue?vue&type=template&id=fc768a48"
import script from "./graph_methanogenic_potential_per_interface.js?vue&type=script&lang=js&external"
export * from "./graph_methanogenic_potential_per_interface.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports